<template>
  <div class="app-container">
    <!-- 查询条件 -->
    <div ref="searchBox" class="formBox margbot">
      <el-form :inline="true" :model="formData" class="demo-form-inline" ref="formData" size="mini">
        <el-form-item label="安全帽编号:">
          <el-input type="text" v-model="formData.safetyHatNo" size="mini" placeholder="请输入安全帽编号"></el-input>
        </el-form-item>
        <br />
        <el-form-item>
          <el-button type="primary" size="mini" @click="chaxun" btnCode="003M3I0100" v-if="btnFlg[0]">查询</el-button>
          <el-button type="primary" size="mini" @click="chongzhi" btnCode="003M3I0200" v-if="btnFlg[1]">重置</el-button>
          <el-button type="primary" size="mini" @click="xinzeng" btnCode="003M3I0300" v-if="btnFlg[2]">新增</el-button>
          <el-button type="primary" size="mini" @click="xiugai" btnCode="003M3I0400" v-if="btnFlg[3]">修改</el-button>
          <el-button type="primary" size="mini" @click="shanchu" btnCode="003M3I0500" v-if="btnFlg[4]">删除</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 表格 -->
    <div :style="{ height: h }">
      <el-table height="100%" size="mini" border center bordersize="mini" ref="tabref" :data="tableData" style="width: 100%" class="tableComent" :header-cell-style="{ background: '#F5F5F5', color: 'black' }" highlight-current-row @row-click="dianjixuanzhong" @selection-change="selectionChange">
        <el-table-column type="selection"></el-table-column>
        <el-table-column fixed type="index" align="center" label="序号" width="60"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="safetyHatNo" label="安全帽编号" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="remark" label="备注" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="createUser" label="创建人" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="createTime" label="创建时间" align="center"></el-table-column>
        <!-- <el-table-column width="100" label="操作" align="center">
          <template v-slot='scope'>
            <el-button type="text" :disabled="jkDis" @click="jiankong(scope.row)">实时视频</el-button>
          </template>
        </el-table-column> -->
      </el-table>
    </div>
    <div class="pags" style="text-align: right">
      <el-pagination background @current-change="handleCurrentChange" :current-page="pageInfo.pageNo" :page-size="pageInfo.pageSize" :page-sizes="[10, 20, 30, 40, 50]" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" :total="total"></el-pagination>
    </div>
    <!-- 监控 -->
    <el-dialog title="监控" v-if="dialogJKVisible" :visible.sync="dialogJKVisible" width="80%" top="7vh" center :before-close="closeJk" :close-on-click-modal="false">
      <div style="width: 100%;height:411px;">
        <VideoPlayer :url="videoUrl" ref='video' />
      </div>
    </el-dialog>
    <!-- 新增 -->
    <el-dialog :title="title" v-if="dialogAddVisible" :visible.sync="dialogAddVisible" width="30%" center :before-close="addQuXiao" :close-on-click-modal="false">
      <div style="width: 100%">
        <div class="addMarkBox-content">
          <!--form表单-->
          <el-form :model="AddformData" ref="AddformData" label-width="100px" class="demo-dynamic" style="width:350px;margin:30px auto;">
            <el-form-item label="安全帽编号" :rules="[
                { required: true, message: '请输入安全帽编号', trigger: 'blur' },
              ]" prop="safetyHatNo">
              <el-input type="text" v-model="AddformData.safetyHatNo" size="mini" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="备注信息" :rules="[
                { required: false, message: '请选择备注信息', trigger: 'blur' },
              ]" prop="addOldKeHuName">
              <el-input type="textarea" v-model="AddformData.remark" size="mini" placeholder="备注"></el-input>
            </el-form-item>
          </el-form>
        </div>

        <div style="width:158px;margin:15px auto;">
          <el-button type="primary" @click="addHatOk">确定</el-button>
          <el-button type="primary" @click="addQuXiao">取消</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getHatList,
  addHat,
  deleteHat,
  modifySafetyHat,
  jiankongToken
} from '@/api/wms-stock'
import VideoPlayer from './TcPlayer.vue'
import { getBtn } from '@/utils/getButton'
export default {
  components: { VideoPlayer },
  data () {
    return {
      formData: {
        safetyHatNo: ''
      },
      pageInfo: {
        pageNo: 1,
        pageSize: 20
      },
      h: '500px',
      tableData: [],
      btnArr: [
        '003M3I0100',
        '003M3I0200',
        '003M3I0300',
        '003M3I0400',
        '003M3I0500'
      ],
      btnFlg: [],
      total: 0,
      dialogJKVisible: false,
      jkDis: false,
      isLogin: false,
      webSocket: null,
      wsUrl: 'wss://caps.runde.pro/wss',
      adminName: 'CS870W',
      device_id: '',
      Intervel: null,
      videoUrl: '',
      socketClosed: false,
      // 新增
      dialogAddVisible: false,
      AddformData: {
        safetyHatNo: '',
        remark: ''
      },
      xuanzhongarr: [],
      title: '新增',
      safetyHatIds: '',
      selection: []
    }
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 168 + 'px'
    this.getInventoryList()

    // this.initWebSocket()
  },
  // beforeDestroy () {
  //   window.clearInterval(this.Intervel)
  //   this.Intervel = null
  //   this.socketClosed = false
  //   // 离开路由之后断开websocket连接
  //   this.webSocket.close()
  // },
  created () {
    this.btnFlg = getBtn(this.btnArr, '/addInventory')
  },
  methods: {
    closeJk () {
      window.clearInterval(this.Intervel)
      this.Intervel = null
      this.dialogJKVisible = false

      this.$refs.video.pause()
      setTimeout(() => {
        this.websocketsend(
          JSON.stringify({ act: 'ma_stop_rtsp', device_id: this.device_id })
        )
      }, 2000)
    },
    async jiankong (row) {
      this.jkDis = true
      this.device_id = row.safetyHatNo
      if (this.socketClosed) {
        this.initWebSocket()
      }

      const token = await jiankongToken()
      this.websocketsend(
        JSON.stringify({
          act: 'ma_login',
          user_name: this.adminName,
          access_token: token
        })
      )
    },
    initWebSocket () {
      this.webSocket = new WebSocket(this.wsUrl)
      this.webSocket.onmessage = this.websocketOnMessage
      this.webSocket.onopen = this.websocketOnOpen
      this.webSocket.onerror = this.websocketOnError
      this.webSocket.onclose = this.websocketOnClose
    },
    websocketOnMessage (e) {
      console.log(e.data)
      const jsons = JSON.parse(e.data)
      switch (jsons.cmd) {
        case 'ma_login':
          if (jsons.msg_code == 'TooManyLogin') {
            this.jkDis = false
          }
          this.isLogin = true
          this.websocketsend(JSON.stringify({ act: 'ma_get_active_devices' }))
          this.Intervel = window.setInterval(() => {
            this.websocketsend(
              JSON.stringify({ act: 'ma_get_active_devices' })
            )
          }, 25000)
          break
        case 'ma_get_active_devices':
          // console.log(jsons.msg_code)
          const isActive = jsons.data.some(item => item.user_info.device_id == this.device_id)
          console.log(isActive, jsons, this.device_id)
          if (jsons.msg_code == 'HaveNoDeviceOnLine' || !isActive) {
            this.$message({ message: '设备未登录', type: 'error' })
            this.jkDis = false
            window.clearInterval(this.Intervel)
            this.Intervel = null
          } else {
            if (this.jkDis) {
              this.websocketsend(
                JSON.stringify({ act: 'ma_open_rtsp', device_id: this.device_id })
              )
            }
          }
          break
        case 'ma_open_rtsp':
          if (jsons.status) {
            const url = jsons.play_url[2].replace('\\', '')
            this.videoUrl = url
            this.dialogJKVisible = true
          } else {
            this.jkDis = false
            this.$message({ message: jsons.msg, type: 'error' })
          }

          break
        case 'ma_stop_rtsp':
          console.log('停止推流')
          this.jkDis = false

          window.clearInterval(this.Intervel)
          this.Intervel = null
          break
      }
    },
    websocketOnOpen () {
      console.log('websocket已开启')
    },
    websocketOnError () {
      this.initWebSocket()
    },
    websocketsend (Data) {
      // 数据发送
      this.webSocket.send(Data)
    },
    websocketOnClose () {
      this.socketClosed = true
      console.log('websocket已关闭')
    },
    getInventoryList () {
      getHatList({
        ...this.formData,
        ...this.pageInfo
      }).then(res => {
        this.tableData = res.list
        this.total = res.total
      })
        .catch(error => {
          this.$message.error(error.message)
        })
    },
    chaxun () {
      this.getInventoryList()
    },
    chongzhi () {
      this.formData.safetyHatNo = ''
      this.getInventoryList()
    },
    handleCurrentChange (val) {
      this.pageInfo.pageNo = val
      this.chaxun()
    },
    handleSizeChange (val) {
      this.pageInfo.pageSize = val
      this.chaxun()
    },
    dianjixuanzhong (row) {
      this.xuanzhongarr = row
    },
    shanchu () {
      if (this.safetyHatIds == '') {
        this.$message.error('请选择一条数据')
      } else {
        this.$confirm('确认删除安全帽吗？', '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          deleteHat({ safetyHatIds: this.safetyHatIds })
            .then(res => {
              this.$message({ message: '删除成功', type: 'success' })
              this.getInventoryList()
              this.xuanzhongarr = []
            })
            .catch(err => {
              this.$message({ message: err.message, type: 'error' })
            })
        })
      }
    },
    xinzeng () {
      this.title = '新增'
      this.dialogAddVisible = true
      this.AddformData.safetyHatNo = ''
      this.AddformData.remark = ''
    },
    xiugai () {
      if (this.selection.length != 1) {
        this.$message.error('请选择一条数据')
      } else {
        this.AddformData.safetyHatNo = this.selection[0].safetyHatNo
        this.AddformData.remark = this.selection[0].remark
        this.AddformData.safetyHatId = this.selection[0].safetyHatId
        this.title = '修改'
        this.dialogAddVisible = true
      }
    },
    addHatOk () {
      if (this.title == '新增') {
        this.$refs.AddformData.validate(valid => {
          if (valid) {
            addHat({
              ...this.AddformData
            }).then(res => {
              this.$message.success('成功')
              this.addQuXiao()
              this.getInventoryList()
              this.xuanzhongarr = []
            })
              .catch(error => {
                this.$message.error(error.message)
              })
          }
        })
      } else {
        this.$refs.AddformData.validate(valid => {
          if (valid) {
            modifySafetyHat({
              ...this.AddformData
            }).then(res => {
              this.$message.success('成功')
              this.addQuXiao()
              this.getInventoryList()
              this.xuanzhongarr = []
            })
              .catch(error => {
                this.$message.error(error.message)
              })
          }
        })
      }
    },
    selectionChange (selection) {
      this.selection = selection
      this.safetyHatIds = selection.map(item => item.safetyHatId).join(',')
    },
    addQuXiao () {
      this.AddformData.safetyHatId = ''
      this.AddformData.remark = ''
      this.dialogAddVisible = false
    }
  }

}
</script>

<style lang='less' scoped>
.messages {
  font-size: 16px;
}
.inpBox {
  .el-form-item {
    margin-left: 10px;
    margin-bottom: 0px;
  }
}
</style>
